import React from 'react';
import { FormSection, FormCheckbox } from '@praktio/common-ui';

interface ITeamManagerProps {
  selectedRows?: IUser[];
  teamManagers: IUser[];
  onRowSelect: ({ selected, all }: { selected?: IUser; all?: boolean }) => void;
}

const TeamManagers = ({ selectedRows, teamManagers, onRowSelect }: ITeamManagerProps) => {
  return (
    <FormSection sectionName="Team Managers">
      <FormCheckbox
        id="all-managers"
        label="All Managers"
        className="font-weight-bold"
        checked={selectedRows?.length === teamManagers.length}
        onChange={() => onRowSelect({ all: true })}
      />
      {teamManagers?.length > 0 &&
        teamManagers.map((teamManager) => {
          return (
            <FormCheckbox
              id={teamManager._id as string}
              label={`${teamManager.firstName} ${teamManager.lastName}`}
              checked={!!selectedRows?.some((selectedRow) => selectedRow._id === teamManager._id)}
              onChange={() => onRowSelect({ selected: teamManager })}
            />
          );
        })}
    </FormSection>
  );
};

export default TeamManagers;
